<template> 
  <div class="avatar-wrapper mr-0" :style="wrapperStyle" v-b-tooltip.top="tooltipOptions">
    <img v-if="imageUrl" :src="imageUrl" :alt="name" style="pointer-events: none;">
    <p v-if="!imageUrl" class="initials mb-0" style="pointer-events: none;">{{initials}}</p>
  </div>
</template>
<script>
function getContrastYIQ(hexcolor){
    hexcolor = hexcolor.replace("#", "");
    var r = parseInt(hexcolor.substr(0,2),16);
    var g = parseInt(hexcolor.substr(2,2),16);
    var b = parseInt(hexcolor.substr(4,2),16);
    var yiq = ((r*299)+(g*587)+(b*114))/1000;
    // Return dark gray for light backgrounds and light gray for dark backgrounds
    return (yiq >= 128) ? '#707070' : '#E0E0E0';
}
function hexToRgb(hex) {
    let r = 0, g = 0, b = 0;
    // 3 digits
    if (hex.length === 4) {
        r = parseInt(hex[1] + hex[1], 16);
        g = parseInt(hex[2] + hex[2], 16);
        b = parseInt(hex[3] + hex[3], 16);
    }
    // 6 digits
    else if (hex.length === 7) {
        r = parseInt(hex[1] + hex[2], 16);
        g = parseInt(hex[3] + hex[4], 16);
        b = parseInt(hex[5] + hex[6], 16);
    }
    return {r, g, b};
}

function rgbToHex(r, g, b) {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
}

function adjustBrightness(r, g, b, factor) {
    const newR = Math.min(Math.max(r * factor, 0), 255);
    const newG = Math.min(Math.max(g * factor, 0), 255);
    const newB = Math.min(Math.max(b * factor, 0), 255);
    return {r: newR, g: newG, b: newB};
}

function generateGradient(hex) {
    const {r, g, b} = hexToRgb(hex);
    const darker = adjustBrightness(r, g, b, 0.8);
    const lighter = adjustBrightness(r, g, b, 1.2);
    
    const darkHex = rgbToHex(Math.round(darker.r), Math.round(darker.g), Math.round(darker.b));
    const lightHex = rgbToHex(Math.round(lighter.r), Math.round(lighter.g), Math.round(lighter.b));
    
    return `linear-gradient(to right, ${darkHex}, ${hex}, ${lightHex})`;
}

export default {
  name: 'Avatar',
  props: {
    imageUrl: { type: String, default: '' },
    backgroundColor: { type: String, default: '#FFC0FF' },
    initials: { type: String, default: '?' },
    prettyName: { type: String, default: '' },
    small: { type: Boolean, default: false },
    showTooltip: { type: Boolean, default: true }
  },
  computed: {
    wrapperStyle(){
      return {
        background: generateGradient(this.backgroundColor),
        color: getContrastYIQ(this.backgroundColor),
        width: this.small ? '1.5rem' : '50px',
        height: this.small ? '1.5rem' : '50px',
        fontSize: this.small ? '0.75rem' : '1.5rem',
      }
    },
    tooltipOptions() {
      if (!this.showTooltip) {return}
      return {
        title: this.prettyName,
        delay: { show: 300, hide: 100 },
      };
    }
  }
}
</script>
<style scoped>
  .avatar-wrapper {
    border-radius: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
  }

  .initials {
    font-weight: 600;
  }

  .avatar-wrapper > img {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
</style>